var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeKenya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V13.5H60V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 31.5H0V45H60V31.5Z",
    fill: "#006600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0439 35.8594L37.5377 36.1406L24.4033 13.3594C23.6439 13.1906 23.2221 12.4594 22.8002 11.7281C22.5189 11.2219 21.3939 9.28125 20.9158 6.75C22.2501 7.93572 23.3808 9.33241 24.2627 10.8844C24.6846 11.6156 25.1064 12.3469 24.9096 13.1062L38.0439 35.8594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7012 6.37109L20.7777 6.77609C21.2405 9.22597 22.303 11.1266 22.6382 11.7262C22.6526 11.752 22.6657 11.7755 22.6774 11.7964L22.6779 11.7974L22.6822 11.8049C22.8905 12.1659 23.1069 12.5409 23.3685 12.8462C23.6207 13.1403 23.9223 13.3789 24.3117 13.4818L37.4851 36.3308L38.2373 35.9129L25.0595 13.0846C25.1477 12.6886 25.0836 12.3048 24.9505 11.9369C24.8127 11.5561 24.5966 11.1815 24.3881 10.8201L24.3851 10.8149C24.385 10.8148 24.3849 10.8146 24.3848 10.8145C23.4954 9.2493 22.355 7.84072 21.0093 6.64488L20.7012 6.37109ZM21.1408 7.14565C22.3258 8.25655 23.3372 9.54023 24.1405 10.9538L24.141 10.9546C24.3533 11.3227 24.5574 11.6773 24.686 12.0326C24.8137 12.3854 24.8625 12.7277 24.7735 13.071L24.7591 13.1267L37.8508 35.8059L37.5905 35.9505L24.4943 13.2355L24.4339 13.2221C24.0938 13.1465 23.8231 12.9444 23.5821 12.6632C23.3393 12.3799 23.1349 12.0267 22.9227 11.6589C22.9113 11.6384 22.8985 11.6155 22.8845 11.5905C22.5716 11.0306 21.6295 9.34492 21.1408 7.14565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0439 35.8594L37.5377 36.1406L24.4033 13.3594C23.6439 13.1906 23.2221 12.4594 22.8002 11.7281C22.5189 11.2219 21.3939 9.28125 20.9158 6.75C22.2501 7.93572 23.3808 9.33241 24.2627 10.8844C24.6846 11.6156 25.1064 12.3469 24.9096 13.1062L38.0439 35.8594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0470734 15.75H24.6561C25.4998 13.5 28.3123 9 29.9998 9C31.6873 9 34.4998 13.5 35.3436 15.75H60.0186V29.25H35.3436C34.4998 31.5 31.6873 36 29.9998 36C28.3123 36 25.4998 31.5 24.6561 29.25H-0.0470734V15.75Z",
    fill: "#BB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6562 29.25C23.8125 27 23.25 24.75 23.25 22.5C23.25 20.25 23.8125 18 24.6562 15.75C25.5 18 26.0625 20.25 26.0625 22.5C26.0625 24.75 25.5 27 24.6562 29.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 24.1875C29.3787 24.1875 28.875 23.432 28.875 22.5C28.875 21.568 29.3787 20.8125 30 20.8125C30.6213 20.8125 31.125 21.568 31.125 22.5C31.125 23.432 30.6213 24.1875 30 24.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7188 24.1313C29.7188 24.1313 28.5938 26.3813 28.5938 30.0376C28.5938 33.6938 29.7188 35.9438 29.7188 35.9438V24.1313Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeKenya);
export default __webpack_public_path__ + "static/media/ke Kenya.e64e705141909b1e6b6b90dd307b1004.svg";
export { ForwardRef as ReactComponent };